import { Heading, Text } from "@/components/ui/typography";
import { useUser } from "@/lib/user-context";

export function DashboardHero() {
  const { session } = useUser();
  const fullName = session?.user.name?.trim() ?? "";
  const firstName = fullName.split(/\s+/)[0] || "Legend";

  return (
    <section className="px-2 py-2 md:min-h-48">
      <Text variant="body" tone="muted">
        Good {getTimeOfDay()}
      </Text>
      <Heading variant="display" className="mt-3">
        {firstName}
      </Heading>
      <Text variant="body" tone="muted" className="mt-3 max-w-xl">
        Live overview of attendance, site coverage and workforce activity.
      </Text>
    </section>
  );
}

function getTimeOfDay() {
  const hour = new Date().getHours();
  if (hour < 12) return "morning";
  if (hour < 18) return "afternoon";
  return "evening";
}
